/**
 * --------------------------------------------------------------------------
 * Basic Modules: MobileMenuToggle.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'mobileMenuToggle';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
};

const Event = {
    RESIZE                      : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL                      : `scroll${EVENT_KEY}`,
    CLICK                       : `click${EVENT_KEY}`,
};

const ClassName = {
    MOBILE_MENU_OUTER_ACTIVE    : 'mobile-menu-outer--active',
    MOBILE_MENU_OPEN            : 'mobile-menu-is-open',
    TOGGLE_ACTIVE               : 'is-active',
};

const Selector = {
    MOBILE_MENU_OUTER           : '.mobile-menu-outer',
    TOGGLE                      : '[data-mobile-menu-toggle]',
};

const DataAttr = {
};

class MobileMenuToggle {

    constructor(config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;
        this.toggleMobileMenuTimeout = null;

        this._config  = this._getConfig(config);

        this.mobileMenuOuter = document.querySelector(Selector.MOBILE_MENU_OUTER);
        if (! this.mobileMenuOuter) {
            return;
        }

        let mobileMenuToggleButtons = Array.from(document.querySelectorAll(Selector.TOGGLE));
        mobileMenuToggleButtons.forEach((elem) => {
            $(elem).on(Event.CLICK, (event) => this._handleMobileMenuToggleClick(event));
        });

        this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _handleMobileMenuToggleClick(event) {
        if (this.toggleMobileMenuTimeout) {
            return;
        }

        if (document.body.classList.contains(ClassName.MOBILE_MENU_OPEN)) {
            this.toggleMobileMenuTimeout = setTimeout(() => {
                this.toggleMobileMenuTimeout = null;
                this.mobileMenuOuter.classList.remove(ClassName.MOBILE_MENU_OUTER_ACTIVE);
                this._dispatchMobileMenuClosedEvent();
            }, 500)
        }
        else {
            this.mobileMenuOuter.classList.add(ClassName.MOBILE_MENU_OUTER_ACTIVE);
        }

        document.body.classList.toggle(ClassName.MOBILE_MENU_OPEN);
        document.querySelector(Selector.TOGGLE).classList.toggle(ClassName.TOGGLE_ACTIVE);
    }

    _dispatchMobileMenuClosedEvent() {
        let closeMobileMenuEvent = document.createEvent('Event');
        closeMobileMenuEvent.initEvent('closemobilemenu', true, true);
        window.dispatchEvent(closeMobileMenuEvent);
    }


    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _isMobile() {
        return Util.viewport === 'mobile';
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        // do stuff when window is resized.
        document.body.classList.remove(ClassName.MOBILE_MENU_OPEN);

        if (this.mobileMenuOuter) {
            this.mobileMenuOuter.classList.remove(ClassName.MOBILE_MENU_OUTER_ACTIVE);
        }

        if (this.mobileMenuOuter) {
            this._dispatchMobileMenuClosedEvent();
        }

        document.querySelector(Selector.TOGGLE).classList.remove(ClassName.TOGGLE_ACTIVE);

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     */
    static init (config) {
        new MobileMenuToggle(config);
    }
}

export default MobileMenuToggle;
